import { useSyncExternalStore } from "react";

const KEY = "seenNewFlags";
const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
};
let cache = read();
const listeners = new Set();
const subscribe = (cb) => { listeners.add(cb); return () => listeners.delete(cb); };
const getSnapshot = () => cache;

export function useNewFlags() {
  const seen = useSyncExternalStore(subscribe, getSnapshot);
  return {
    isNewForMe: (d) => !!d.flag_new && seen[d.id] !== (d.flag_new_at || "set"),
    markSeen: (d) => {
      if (!d.flag_new || cache[d.id] === (d.flag_new_at || "set")) return;
      cache = { ...cache, [d.id]: d.flag_new_at || "set" };
      localStorage.setItem(KEY, JSON.stringify(cache));
      listeners.forEach((l) => l());
    },
  };
}
